import React from 'react';

export class AuthLoading extends React.Component {
    render() {
        return <p>Authentication in progress...</p>;
    }
  }